import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { environment } from "src/environments/environment";
import { SyncSessionService } from "../services/sync-session.service";
import { ProfileService } from "src/app/modules/user-management/features/user-profile/user-profile.service";
import { ENTERPRISE_ENDPOINT_MAPPING } from "../constants/enterprise.constant";

export const enterpriseInterceptor: HttpInterceptorFn = (request, next) => {
  const profileService = inject(ProfileService);
  const syncSession = inject(SyncSessionService);
  const baseUrl = environment.BASE_URL;

  if (!syncSession.isSessionReady()) {
    return next(request);
  }

  let endpointPath = request.url.replace(baseUrl, "");
  if (endpointPath.startsWith("/")) {
    endpointPath = endpointPath.substring(1);
  }

  if (!(endpointPath in ENTERPRISE_ENDPOINT_MAPPING)) {
    return next(request);
  }

  const isNumericId = /\/(\d+)/.test(endpointPath);
  if (isNumericId) {
    return next(request);
  }

  if (!profileService.isEnterprise()) {
    return next(request);
  }

  const enterpriseEndpoint = ENTERPRISE_ENDPOINT_MAPPING[endpointPath];
  if (enterpriseEndpoint) {
    const modifiedRequest = request.clone({
      url: `${baseUrl}${enterpriseEndpoint}`,
    });
    return next(modifiedRequest);
  }

  return next(request);
};
